import React from 'react';
import PropTypes from 'prop-types';

import {currentResource} from '../../../util/utils';
import {tablePaginationSizeOptions} from '../../../util/uiconstants';

import selectActivityLogSorting from '../../../reducers/ActivityLog/selectors/selectActivityLogSorting';

import columns from './columns';

import CustomTable from '../../CoreWrappers/CustomTable';
import selectActivityLogPagination from '../../../reducers/ActivityLog/selectors/selectActivityLogPagination';

const ActivityTable = ({items = null, labels, handleGetActivityLog}) => {
	if (!items) return false;

	const {column, direction} = selectActivityLogSorting();
	const {page, totalEntityCount, pageSize} = selectActivityLogPagination();

	const props = {
		id: 'activityTable',
		data: items,
		columns: columns(currentResource.activityTableLabels),
		labels: {
			emptyMessage: labels.noDataToDisplay,
			show: labels.show
		},
		headerMultiline: 2,
		pagination: true,
		paginationOptions: tablePaginationSizeOptions,
		enableBodyScroll: true,
		serverSideState: {
			handler: handleGetActivityLog,
			column,
			direction,
			page,
			totalEntityCount,
			pageSize
		}
	};

	return <CustomTable {...props} />;
};

ActivityTable.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			sourceEngagement: PropTypes.string.isRequired,
			activityType: PropTypes.string.isRequired,
			objectImpacted: PropTypes.string.isRequired,
			relatedObjectImpacted: PropTypes.string.isRequired,
			relatedSecondaryObjectImpacted: PropTypes.string.isRequired,
			activityDate: PropTypes.string.isRequired
		})
	),
	handleGetActivityLog: PropTypes.func.isRequired
};

export default ActivityTable;
